import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';

// Shown under every "enter your code" step. With sign-in by emailed code
// only, a code stuck in spam used to leave people with nowhere to go.
//
// Deliberately loud: most people who never finish signing up were sent a
// working code and simply never found it. The spam line is the single most
// useful sentence on the screen, so it is the one that gets the colour, the
// icon and its own line -- not a grey paragraph people skim past.
const CodeHelp = ({ collapsible = false }) => collapsible ? (
  <details className="border-t border-slate-200 pt-2 text-sm text-slate-600">
    <summary className="min-h-[44px] cursor-pointer py-3 font-medium text-blue-700">Didn’t get the code?</summary>
    <div className="space-y-2 pb-2 leading-6">
      <p>Check your spam or promotions folder. It usually arrives within a minute. Then try <strong>Resend code</strong>. Codes expire after 30 minutes.</p>
      <p>Sign-in codes are for existing accounts. If you’re new, use Create an account above.</p>
      <p>Still nothing? <a href="https://wa.me/918555811800?text=I%20did%20not%20receive%20my%20Serviti%20sign-in%20code" target="_blank" rel="noopener noreferrer" className="font-medium text-blue-700 underline underline-offset-2">Message us on WhatsApp</a> or email <a href="mailto:sales@serviti.ai" className="font-medium text-blue-700 underline underline-offset-2">sales@serviti.ai</a>.</p>
    </div>
  </details>
) : (
  <div className="rounded-lg border-2 border-amber-300 bg-amber-50 p-4 text-sm text-amber-950 shadow-sm">
    <p className="flex items-center gap-2 text-base font-bold text-amber-900">
      <ExclamationTriangleIcon className="h-5 w-5 shrink-0 text-amber-500" aria-hidden="true" />
      Didn&rsquo;t get the code?
    </p>
    <p className="mt-2 text-base font-bold leading-snug text-amber-900">
      Check your spam or promotions folder.
    </p>
    <p className="mt-2">
      It usually arrives within a minute. If it isn&rsquo;t there, use{' '}
      <span className="font-semibold">Resend code</span>. Codes expire after 30 minutes.
    </p>
    <p className="mt-2">
      Still nothing?{' '}
      <a
        href="https://wa.me/918555811800?text=I%20did%20not%20receive%20my%20Serviti%20sign-in%20code"
        target="_blank"
        rel="noopener noreferrer"
        className="font-semibold text-amber-900 underline underline-offset-2"
      >
        Message us on WhatsApp
      </a>
      {' '}or email{' '}
      <a href="mailto:sales@serviti.ai" className="font-semibold text-amber-900 underline underline-offset-2">sales@serviti.ai</a>.
    </p>
  </div>
);

export default CodeHelp;
